import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from '../redux/auth/authReducer';
import userData from '../redux/rootReducer';
import dateReducer from './date/dateReducer';
import notificationsReducer from './notifications/notificationsReducer';

const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['token'],
};

const store = configureStore({
  reducer: {
    auth: persistReducer(authPersistConfig, authReducer),
    user: userData.user,
    habits: userData.habits,
    cigarettes: userData.cigarettes,
    payments: userData.payments,
    quiz: userData.quiz,
    date: dateReducer,
    modal: userData.modal,
    errors: userData.errorsModal,
    error: userData.error,
    loading: userData.loading,
    notifications: notificationsReducer,
  },
  devTools: process.env.NODE_ENV === 'development',
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
});

export const persistor = persistStore(store);

export default store;
